import React, { useState } from 'react'
import '../assets/home.css'
import Footer from './Footer'
import InfoHome from './home/InfoHome'
import FaqCategorie from './FaqCategorie'
import Temoignage from './home/Temoignage'
import Engagement from './home/Engagement'
import CategoryProduct from './home/CategoryProduct'
import Header from './home/Header'
import Menu from './Menu'
import SousBlog from './home/SousBlog';
import { Link } from 'react-router-dom';
import Pub from './home/Pub'

function Home() {
  const [cats] =useState([
      {
        id: 1,
        name: "Best sellers",
        title: "Vos gammes CBD et HHC préférées ",
        image:"/images/categories/bestsellers.png",
      },
      {
        id: 2,
        name: "Nouveautés",
        title: "Les dernières nouveautés pour vous satisfaire  ",
        image:"/images/categories/nouveaute.png",

      },
      {
        id: 3,
        name: "Fleurs",
        title: "CBD, CBG, HHC, HHCP, HHCO il y en a pour tout les goûts avec",
        image:"/images/categories/fleur.png",

      },
      {
        id: 4,
        name: "Résines",
        title: "Résines et pollen de CBD & HHC puissantes ou douces",
        image:"/images/categories/resine.png",

      },
      {
        id: 5,
        name: "Huiles",
        title: "Huile CBD, CBG, HHC, Culinaire",
        image:"/images/categories/huile.png",

      },
      {
        id: 6,
        name: "Commestibles",
        title: "Les bienfaits du CBD à travers des thés, tisanes, bonbons, huiles pour vos plats en cuisine",
        image:"/images/categories/comestible.png",
        
      },
      {
        id: 7,
        name: "E-liquide",
        title: "E-liquide HHC et E-liquide HHC ainsi que le matériel adapté",
        image:"/images/categories/e-liquide.png",

      },
      {
        id: 8,
        name: "E-cigarette",
        title: "Pod HHC, pod CBD, Puff, cigarette électronique HHC et CBD",
        image:"/images/categories/e-cigarette.png",

      },
      {
        id: 9,
        name: "Vaporisateurs",
        title: "Idéal pour la vaporisation de CBD/HHC",
        image:"/images/categories/vaporisateur.png",

      },
      {
        id: 10,
        name: "Soins",
        title: "Pour une meilleure récupération musculaire",
        image:"/images/categories/soins.png",

      },
      {
        id: 11,
        name: "Animaux",
        title: "Parce que eux aussi ont le droit au CBD",
        image:"/images/categories/animaux.png",

      },
    ]);
    
      const produits = [{
        id: 1,
        nom: "Gelato HHCP 7%",
        prix: "13,90€ - 11,00€/g",
        note: "4,5",
        avis: "8",
        image: "/images/produits/gelato.png"
      },{
        id: 2,
        nom: "Pack Shoptapromotion - CBD, CBG, HHC, HHCP...",
        prix: "7,00€ - 6,00€/g ",
        note: "4,5",
        avis: "8",
        image: "/images/produits/pack.png"
      },{
        id: 3,
        nom: "Fruity Punch HHC 50% + CBD 10%",
        prix: "13,90€ - 11,00€/g",
        note: "4,5",
        avis: "8",
        image: "/images/produits/fruity.png"
      },{
        id: 4,
        nom: "Runtz HHC 50% + 10% CBD",
        prix: "13,90€ - 11,00€/g",
        note: "4,5",
        avis: "8",
        image: "/images/produits/runz.png"
      },{
        id: 5,
        nom: "Pack Shoptapromotion - CBD, CBG, HHC, HHCP...",
        prix: "7,00€ - 6,00€/g ",
        note: "4,5",
        avis: "8",
        image: "/images/produits/pack.png"
      },{
        id: 6,
        nom: "Runtz HHC 50% + 10% CBD",
        prix: "13,90€ - 11,00€/g",
        note: "4,5",
        avis: "8",
        image: "/images/produits/runz.png"
      }
    ];
    
  return (
    <div>
        <Menu />
      <Header />    
      <div className="categories-list container-fluid">
        {cats.map(cat =><div className="cat" key={cat.id}>
        <Link to={{pathname:"/categories/"+cat.id}}><img src={window.location.origin +cat.image} alt="" className="cat-img" /></Link>
          <p className='text-capitalize'><Link className='list-name text-capitalize' to={{pathname:"/categories/"+cat.id}}>{cat.name}</Link></p>
        </div>)}       
      </div>
      <CategoryProduct produits={produits} idCat={1} catTitle={"BEST SELLERS"} />
      <Pub />
      <CategoryProduct produits={produits} idCat={2} catTitle={"NOUVEAUTÉS"} />
      <Engagement />
      <div className="container-fluid" id='about'>
        <div className="cat-header">
            <h4 className='cat-subtitle mt-3'>MÉDIA</h4>
            <h3 className='cat-title'>ILS PARLENT DE NOUS</h3>
        </div>
        <div className="about-img">
          <img src={window.location.origin +'/images/newsweed.png'} alt=""  />
          <img src={window.location.origin +'/images/lepoint.png'} alt=""/>
          <img src={window.location.origin +'/images/challenge.png'} alt=""/>
        </div>
      </div>
      <Temoignage />
      <FaqCategorie />
      <SousBlog />
      <InfoHome />
      <Footer />
    </div>
  )
}

export default Home